var render = function () {
  var _vm$item, _vm$item$thumb, _vm$item2, _vm$item3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    attrs: {
      "outlined": ""
    }
  }, 'v-card', {
    to: _vm.to
  }, false), [_c('v-row', [_c('v-col', {
    staticClass: "mb-20 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('div', {
    staticClass: "pr-lg-40 w-100"
  }, [_c('v-img', {
    staticClass: "rounded-lg w-100",
    attrs: {
      "aspect-ratio": 1 / 1,
      "src": (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : (_vm$item$thumb = _vm$item.thumb) === null || _vm$item$thumb === void 0 ? void 0 : _vm$item$thumb.url
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function fn() {
        return [_c('v-overlay', {
          attrs: {
            "absolute": "",
            "z-index": "0",
            "opacity": ".1"
          }
        }, [_c('v-icon', [_vm._v("mdi-image")])], 1)];
      },
      proxy: true
    }])
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "pl-lg-10"
  }, [_c('div', {
    staticClass: "rental__head pr-md-154 pr-lg-190"
  }, [_c('h3', {
    staticClass: "tit line-height-12 mb-8 mb-md-0"
  }, [_vm._v(_vm._s((_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.name))]), _c('div', {
    staticClass: "rental__head-btn"
  }, [!_vm.readonly ? _c('v-btn', {
    staticClass: "mr-4 mr-lg-8 d-flex",
    attrs: {
      "x-small": "",
      "elevation": "0",
      "rounded": "",
      "color": "primary",
      "disabled": _vm.item.isRentDisabled
    }
  }, [_vm._v("예약하기")]) : _vm._e(), (_vm$item3 = _vm.item) !== null && _vm$item3 !== void 0 && _vm$item3.detail ? _c('rental-subject-detail-dialog', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "x-small": "",
            "color": "grey",
            "rounded": "",
            "outlined": ""
          },
          on: {
            "!click": function click($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return on.click($event);
            }
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "grey-dark--text"
        }, [_vm._v("상세보기")])])];
      }
    }], null, false, 3280869955)
  }, 'rental-subject-detail-dialog', {
    item: _vm.item
  }, false)) : _vm._e()], 1)]), _c('v-divider', {
    staticClass: "my-12 my-lg-30"
  }), _c('ul', {
    staticClass: "rental__info page-text grey-dark--text"
  }, _vm._l(_vm.descriptions, function (_ref2) {
    var text = _ref2.text,
      value = _ref2.value;
    return _c('li', {
      key: text,
      staticClass: "d-flex"
    }, [_c('p', {
      staticClass: "min-w-80px mr-12"
    }, [_c('strong', {
      staticClass: "font-weight-bold"
    }, [_vm._v(" " + _vm._s(text) + " ")])]), _c('p', [_vm._v(" " + _vm._s(value) + " ")])]);
  }), 0)], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }